import {ROW_DRAG_HANDLE_WIDTH} from '../react_table/use-row-drag-handle'

export const ROADMAP_ROW_HEIGHT = 40
export const ROADMAP_PILL_HEIGHT = 28

/** The default width to use for the title column in the Roadmap layout, overriding the default width for the column */
export const ROADMAP_TITLE_COLUMN_DEFAULT_WIDTH = 350
export const ROADMAP_TITLE_COLUMN_MAX_WIDTH = 1000
export const ROADMAP_TITLE_COLUMN_MIN_WIDTH = 75
export const ROADMAP_NUMBER_COLUMN_WIDTH = ROW_DRAG_HANDLE_WIDTH
export const ROADMAP_DATE_COLUMN_WIDTH = 120
